/**
 * Changelog entries for the PDF → JRXML converter.
 *
 * Add new entries at the TOP of the list; the dialog renders them
 * in array order, newest first. Each entry's notes are bullets in
 * user-facing language — describe what changed from the user's
 * perspective, not implementation details.
 *
 * The first entry's `tag` doubles as the value passed to the
 * "what's new" indicator dot: when the user opens the dialog the
 * tag is persisted to localStorage so the dot only shows again
 * when a newer entry's tag appears at the top.
 */ var _changelog_;
export const changelog = [
    {
        tag: "2026-06-02-shapes-and-images",
        version: "v1.2.0",
        date: "2026-06-02",
        changes: [
            "Vector shapes and embedded images now appear in the JRXML output."
        ]
    },
    {
        tag: "2026-05-29-initial",
        version: "v1.0.0",
        date: "2026-05-29",
        changes: [
            "PDF → JRXML conversion."
        ]
    }
];
const SEEN_KEY = "pdf2jrxml-changelog-seen-tag";
var _changelog__tag;
/** Latest entry's tag — the value we compare against the user's "seen" record. */ export const latestChangelogTag = (_changelog__tag = (_changelog_ = changelog[0]) === null || _changelog_ === void 0 ? void 0 : _changelog_.tag) !== null && _changelog__tag !== void 0 ? _changelog__tag : "";
/**
 * Returns true when the latest changelog entry hasn't been opened yet
 * (or when localStorage is unavailable — better to highlight than hide).
 */ export function hasUnreadChangelog() {
    if ("object" === "undefined") return false;
    try {
        return window.localStorage.getItem(SEEN_KEY) !== latestChangelogTag;
    } catch (e) {
        return true;
    }
}
/** Record that the user has opened the changelog at its current latest tag. */ export function markChangelogSeen() {
    if ("object" === "undefined") return;
    try {
        window.localStorage.setItem(SEEN_KEY, latestChangelogTag);
    } catch (e) {
    // localStorage may be disabled (private mode, third-party-iframe).
    // Swallowing silently is fine — the only consequence is the dot
    // staying visible.
    }
}
